import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":_vm.id}},[_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12"}},_vm._l((_vm.sections),function(section){return _c(`section-${section}`,{key:section,tag:"component"})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }